import React, { useState } from "react";

// Teacher override codes (work in place of a student's ID):
//   1234 → sign in this one student   9876 → sign in everyone currently out
const OVERRIDE_ONE = "1234";
const OVERRIDE_ALL = "9876";

// Modal shown on the Sign-Out page when "Require student ID to sign back in"
// is enabled. Confirms the returning student's identity before signing in.
// onConfirmAll is optional — when provided, the 9876 override is accepted.
export default function ReturnIdPrompt({ studentName, expectedId, onConfirm, onConfirmAll, onCancel }) {
  const [entry, setEntry] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    const v = entry.trim();
    if (v === OVERRIDE_ALL && onConfirmAll) {
      onConfirmAll();
    } else if (v === OVERRIDE_ONE || v === String(expectedId).trim()) {
      onConfirm();
    } else {
      setError("That ID doesn't match. Try again.");
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000,
    }}>
      <div style={{
        background: "#fff", borderRadius: 20, padding: "36px 32px",
        maxWidth: 420, width: "95%", textAlign: "center",
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
      }}>
        <h2 style={{ margin: "0 0 6px", fontSize: 22 }}>{studentName}</h2>
        <p style={{ color: "var(--color-secondary)", marginBottom: 20, fontSize: 15 }}>
          Enter your student ID to sign back in.
        </p>
        <input
          type="text"
          inputMode="numeric"
          placeholder="Student ID"
          value={entry}
          onChange={e => { setEntry(e.target.value); setError(""); }}
          onKeyDown={e => e.key === "Enter" && entry.trim() && submit()}
          autoFocus
          style={{ width: "100%", padding: "11px 14px", fontSize: 15, borderRadius: 8, border: "1px solid #ddd", boxSizing: "border-box", marginBottom: 10 }}
        />
        {error && <p style={{ color: "red", marginBottom: 10, fontSize: 14 }}>{error}</p>}
        <button
          onClick={submit}
          disabled={!entry.trim()}
          style={{ width: "100%", padding: "14px", fontSize: 15, borderRadius: 12, fontWeight: 500, marginBottom: 10 }}
        >
          Sign In
        </button>
        <button
          onClick={onCancel}
          style={{
            background: "none", border: "1px solid #e0e0e0",
            color: "var(--color-secondary)", padding: "9px 28px",
            borderRadius: 8, cursor: "pointer", fontSize: 14,
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
